export default{
  websiteIndex:{
      path: '/website/index',
      name: 'website-index',
      component: () => import('./index.vue')
  }
}